import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { EngagementCampaignPostStatusForInsightCheck } from '@anytag/graphql';
import { Form } from '@anytag/shared-atoms';
import { usePostsInsightStatusOptions } from '@anytag/shared-hooks';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { formatIntNumber } from '@anytag/shared-utils';
import { PostInsightStatus } from '../PostInsightStatus';
import { PostsInsightFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
  totalConfirmed?: number;
  totalUnconfirmed?: number;
}

export const Template = ({ totalConfirmed, totalUnconfirmed, onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const { postsInsightStatusOptions } = usePostsInsightStatusOptions();

  return (
    <>
      <Form.Fields className="items-center">
        <Form.Field className="flex items-center">
          <h2 css={styles.title}>{t('Report Insight Check')}</h2>

          <div css={styles.count}>
            <div>{formatIntNumber(totalConfirmed)}</div>
            <PostInsightStatus
              css={{ fontSize: '10px', height: '16px' }}
              status={EngagementCampaignPostStatusForInsightCheck.CONFIRMED}
            />
          </div>

          <div css={styles.count}>
            <div>{formatIntNumber(totalUnconfirmed)}</div>
            <PostInsightStatus
              css={{ fontSize: '10px', height: '16px' }}
              status={EngagementCampaignPostStatusForInsightCheck.UNCONFIRMED}
            />
          </div>
        </Form.Field>

        <SelectorField<PostsInsightFilterFormKeys>
          name="status"
          onSubmit={onSubmit}
          className="ml-3.5 max-w-48.5"
          options={postsInsightStatusOptions}
          placeholder={t<string>('Selector.Status')}
        />
      </Form.Fields>

      <TextSearchField<PostsInsightFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.PostsInsightFilter')}
      />
    </>
  );
};
const styles = {
  title: css({ fontWeight: 600, fontSize: '18px', flex: '1 1 auto' }),
  count: css({
    marginLeft: '13px',
    textAlign: 'center',
    '& > div:first-of-type': { fontWeight: 600, fontSize: '16px', marginBottom: '4px' }
  })
};
